export const topLevelDomains = [
    'com',
    'com.br',
    'ch',
    'net',
    'de',
    'eu',
    'fr',
    'it',
    'at',
    'ru',
    'cz',
    'sk',
    'es',
    'cat',
    'com.ar',
    'co.uk',
    'hu',
    'kz',
    'pl',
    'be',
    'nl',
    'fm',
    'ua',
];
